import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  "data-test": "record-header",
  class: "record-header"
}
const _hoisted_2 = { class: "record-header__who" }
const _hoisted_3 = {
  "data-test": "name",
  class: "record-header__name"
}
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "record-header__badge-text" }
const _hoisted_6 = {
  key: 1,
  "data-test": "inline-stats",
  class: "record-header__inline"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 2,
  "data-test": "who-actions",
  class: "record-header__who-actions"
}
const _hoisted_9 = { class: "record-header__tabs" }
const _hoisted_10 = {
  "data-test": "tab-actions",
  class: "record-header__tab-actions"
}

import { ArrowLeftIcon } from '@heroicons/vue/20/solid'
import { computed, watch } from 'vue'

import CustomerActionsMenu from '@/components/customers/CustomerActionsMenu.vue'
import NeueTabs from '@/components/neue/NeueTabs.vue'
import { lifetimeInlineStats } from '@/composables/useCustomerLifetimeStats'
import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'CustomerProfileHeader',
  props: {
  conversationUserPairId: { type: String, required: true },
  activeTab: { type: String, required: true },
  tabs: { type: Array, required: true },
  lifetimeState: { type: String, default: 'loading' },
  lifetime: { type: Object, default: null },
  compact: { type: Boolean, default: false },
  canCreateOrders: { type: Boolean, default: false }
},
  emits: ['new-order'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const sectionTabs = computed(() =>
  props.tabs.map(tab => ({ id: tab.key, name: tab.label, to: tab.to, active: tab.key === props.activeTab }))
)

const conversationUserPair = computed(() =>
  mapRelationship({ type: 'conversation_user_pair', id: props.conversationUserPairId })
)

const name = computed(() => conversationUserPair.value?.attributes?.display_name)

const marketingOptStatus = computed(() => conversationUserPair.value?.attributes?.marketing_opt_status)

const optLabel = computed(() => (marketingOptStatus.value === 'opted_out' ? 'Opted out' : 'Opted in'))

const marketingOptTooltip = computed(() => {
  const status = marketingOptStatus.value
  const optedAt = conversationUserPair.value?.attributes?.marketing_opted_at
  if (!status) return ''
  const dateStr = optedAt ? new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(new Date(optedAt)) : ''
  return status === 'opted_out'
    ? `Customer Opted Out of Messages on ${dateStr}`
    : `Customer Opted in to Messages on ${dateStr}`
})

const inlineStats = computed(() => (props.lifetimeState === 'ready' ? lifetimeInlineStats(props.lifetime) : []))

watch(
  () => props.conversationUserPairId,
  id => {
    if (!mapRelationship({ type: 'conversation_user_pair', id })) api.call('GET', `conversation_user_pairs/${id}`)
  },
  { immediate: true }
)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")
  const _directive_tippy = _resolveDirective("tippy")

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/messages",
        class: "record-header__back",
        title: "Back to messages",
        "aria-label": "Back to messages"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowLeftIcon), {
            class: "record-header__back-icon",
            "aria-hidden": "true"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "record-header__back-text" }, "Messages", -1))
        ]),
        _: 1
      }),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(name.value), 1),
      (marketingOptStatus.value)
        ? _withDirectives((_openBlock(), _createElementBlock("span", {
            key: 0,
            "data-test": "opt-badge",
            role: "img",
            class: _normalizeClass(["record-header__badge", marketingOptStatus.value === 'opted_out' ? 'is-out' : 'is-in']),
            "aria-label": optLabel.value
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(optLabel.value), 1)
          ], 10, _hoisted_4)), [
            [_directive_tippy, { content: marketingOptTooltip.value, delay: 0 }]
          ])
        : _createCommentVNode("", true),
      (inlineStats.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inlineStats.value, (stat) => {
              return (_openBlock(), _createElementBlock("span", {
                key: stat.key,
                "data-test": "inline-stat",
                class: _normalizeClass(["record-header__stat", stat.drop && 'is-droppable'])
              }, [
                (stat.value)
                  ? (_openBlock(), _createElementBlock("b", _hoisted_7, _toDisplayString(stat.value), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(stat.label), 1)
              ], 2))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.compact)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(CustomerActionsMenu, {
              "conversation-user-pair-id": __props.conversationUserPairId,
              "can-create-orders": __props.canCreateOrders,
              onNewOrder: _cache[0] || (_cache[0] = $event => (emit('new-order')))
            }, null, 8, ["conversation-user-pair-id", "can-create-orders"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(NeueTabs, {
        "data-tour": __props.tabs.length > 1 ? 'customer-tabs' : undefined,
        tabs: sectionTabs.value,
        "aria-label": "Customer sections"
      }, null, 8, ["data-tour", "tabs"]),
      _createElementVNode("div", _hoisted_10, [
        (!__props.compact)
          ? (_openBlock(), _createBlock(CustomerActionsMenu, {
              key: 0,
              "conversation-user-pair-id": __props.conversationUserPairId,
              "can-create-orders": __props.canCreateOrders,
              onNewOrder: _cache[1] || (_cache[1] = $event => (emit('new-order')))
            }, null, 8, ["conversation-user-pair-id", "can-create-orders"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

}